import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "blockSwiper-topList"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "block-titleSmall mt10 visible-xs-block" }, "Популярные категории:", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "blockSwiper-topList__promo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "blockSwiper-topList__promo-text" }, "Обратите внимание на популярные категории!")
], -1 /* HOISTED */)
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton_slider = _resolveComponent("skeleton-slider")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (this.loading)
    ? (_openBlock(), _createBlock(_component_skeleton_slider, { key: 0 }))
    : (this.sliders.length > 0 && !$data.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_swiper, {
            scrollbar: {hide: false,draggable: true},
            "slides-per-view": 'auto',
            spaceBetween: 15,
            breakpoints: this.sliderBreakpoints,
            class: "blockSwiper-topList__swiper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.sliders, (slider) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (slider.fileType === 'image')
                    ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 0 }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: slider.url,
                            class: "blockSwiper-topList__swiper-item"
                          }, [
                            _createElementVNode("img", {
                              src: slider.image.url
                            }, null, 8 /* PROPS */, _hoisted_5),
                            _createElementVNode("span", null, _toDisplayString(slider.title), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_4)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["breakpoints"])
        ]))
      : _createCommentVNode("v-if", true)
}